import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Loading from '../a/Loading'
import Text from '../a/Text'
import MissingFile from '#components/svg/icons/MissingFile'
import {useSharedFileUrl} from '#hooks/useSharedFileUrl'

export function UserImage(props) {
  const {blobId, userId, originalFilename} = props
  const userFile = useSharedFileUrl(blobId, userId)

  return (
    <div className="userimage">
      {userFile.url && <img src={userFile.url} alt={originalFilename} />}
      {userFile.isLoading && <Loading />}
      {userFile.notFound && (
        <div className="userimage__not__found">
          <MissingFile className="userimage__not__found__image" />
          <Text text={i18n.t('picture_not_found')} />
        </div>
      )}
    </div>
  )
}

UserImage.propTypes = {
  userId: PropTypes.number.isRequired,
  blobId: PropTypes.string.isRequired,
  originalFilename: PropTypes.string.isRequired,
}

export default UserImage
